import React from "react";

function Hero() {
  return (
    <section className="container-fluid" id="supportHero">
      <div className="p-5 mt-5" id="supportWrapper">
        <h3>Support Portal</h3>
        <a href="">Track Tickets</a>
      </div>
      <div className="row p-3 mx-5">
        <div className="col-5 p-3 ">
          <h1 className="fs-3">
            Search for an answer or browse help topics to create a ticket
          </h1>
          <input placeholder="Eg. how do I activate F&O" />
          <br />
          <a href="">Track account opening</a>
          <a href="">Track segment activation</a>
          <a href="">Intraday margin</a>
          <a href="">Kite user manual</a>
        </div>
        <div className="col-2 p-3 "></div>
        <div className="col-5 p-3">
          <h1 className="fs-3">Featured</h1>

          <ol>
            <li>
              {" "}
              <a href="">Current Takeovers and Delisting- january 2024</a>
            </li>
            <li>
              <a href="">Latest Intraday Leverages - MIS & CO</a>
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
}

export default Hero;
